<template>
  <div class="content">
    <big-one :content="content" :type = "type" :default-value-filter="valueFilter"
             :page-limits="filterMap" tuning="true" :a-page="true"></big-one>
  </div>
</template>
<script>

const callDate = {header: "Звонок запланирован", name: "nextCallTime", show: true, sort: true, direction: true, date: true};
const clientName = {header: "Клиент", name: "name", show: true, contains: ""};
const clientPhone = {header: "Телефон", name: "contact.phone", show: true};
const clientAddress = {header: "Адрес", name: "contact.address", show: true, contains: ""};
const callsExecutor = {header: "Исполнитель", name: "lastCaller", show: true, contains: ""};

export default{
  data() {
    return {
      type: "client",
      content: [callDate, callsExecutor, clientName, clientPhone, clientAddress],
      newOne: null,
      objects: null,
      valueFilter: {"nextCallTime": {"before_current": 259200000}},
      filterMap: {"archivedDate": "null"}
    }
  },
  methods: {
  }
}
</script>
<style>
</style>
